import FeedController from "PFApp/feed/feed_controller";
import NotFoundRoute from "PFApp/routes/not_found_route";
import { EnsureFeatureEnabled, EnsureLoggedInAndRegistered, WithLayout } from "PFApp/routes/route_helpers";
import { FeatureFlag } from "PFTypes";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const FeedRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedInAndRegistered>
      <EnsureFeatureEnabled feature={FeatureFlag.ActivityFeed}>
        <WithLayout>
          <Switch>
            <Route path={`${path}/:section?/:childActivityIds?`}>
              <FeedController />
            </Route>
            <Route path="*">
              <NotFoundRoute />
            </Route>
          </Switch>
        </WithLayout>
      </EnsureFeatureEnabled>
    </EnsureLoggedInAndRegistered>
  );
};

export default FeedRoutes;
